"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Button = _interopRequireDefault(require("../Buttons/Button"));

var _SmallText = _interopRequireDefault(require("../TitlesAndTexts/SmallText"));

var _BaseTheme = _interopRequireDefault(require("../Themes/BaseTheme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const Container = _styledComponents.default.div.withConfig({
  displayName: "FileInput__Container",
  componentId: "design-system__sc-1wc74vj-0"
})(["width:100%;box-sizing:border-box;"]);

const InputContainer = _styledComponents.default.div.withConfig({
  displayName: "FileInput__InputContainer",
  componentId: "design-system__sc-1wc74vj-1"
})(["position:relative;width:100%;box-sizing:border-box;padding:16px;border-radius:3px;border:2px solid ", ";"], _BaseTheme.default.colors.bluegray);

const Input = _styledComponents.default.input.withConfig({
  displayName: "FileInput__Input",
  componentId: "design-system__sc-1wc74vj-2"
})(["position:absolute;top:0;left:0;width:100%;height:100%;opacity:0;z-index:10;cursor:pointer;"]);

const FileName = _styledComponents.default.span.withConfig({
  displayName: "FileInput__FileName",
  componentId: "design-system__sc-1wc74vj-3"
})(["margin-left:24px;color:", ";font-family:", ";font-size:", ";"], _BaseTheme.default.colors.textgray, _BaseTheme.default.type.family.content, _BaseTheme.default.type.size.small);

const HelperText = (0, _styledComponents.default)(_SmallText.default).withConfig({
  displayName: "FileInput__HelperText",
  componentId: "design-system__sc-1wc74vj-4"
})(["font-family:", ";color:", ";line-height:24px;margin-top:8px;"], _BaseTheme.default.type.family.system, _BaseTheme.default.colors.lightgray);

const FileInput = _ref => {
  let {
    buttonLabel,
    fileName,
    legend,
    register,
    helperText
  } = _ref,
      props = _objectWithoutProperties(_ref, ["buttonLabel", "fileName", "legend", "register", "helperText"]);

  return /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(InputContainer, null, /*#__PURE__*/_react.default.createElement(Input, _extends({
    type: "file",
    ref: register
  }, props)), /*#__PURE__*/_react.default.createElement(_Button.default, {
    type: "outlined"
  }, buttonLabel), /*#__PURE__*/_react.default.createElement(FileName, null, fileName)), helperText && /*#__PURE__*/_react.default.createElement(HelperText, null, helperText));
};

FileInput.propTypes = {
  buttonLabel: _propTypes.default.string,
  fileName: _propTypes.default.string,
  legend: _propTypes.default.string,
  register: _propTypes.default.func,
  helperText: _propTypes.default.string
};
FileInput.defaultProps = {
  buttonLabel: 'Choose a file',
  fileName: '',
  legend: '',
  helperText: '',
  register: () => {}
};
var _default = FileInput;
exports.default = _default;